import _ from 'underscore';
import { getCallForwardingGridColumnConfig } from './callforwarding-grid-column-config';
import { Constants } from '../constants';
import { columnConfigToColumnChooserConfig } from '../column-config-to-chooser-config';

export function getCallForwardingGridConfig({
  i18n,
  jsDataCampaign,
  edm,
  callForwardingSchema,
  getCurrentLevel,
  deleteSchema,
  bingadsGridColumn,
  gridType,
  isForVNext,
}) {
  const callForwardingColumnConfig = getCallForwardingGridColumnConfig({
    i18n,
    bingadsGridColumn,
  });
  const level = getCurrentLevel();
  return {
    getColumns: () => callForwardingColumnConfig.getLevelOfDetailColumns(level)
      .concat(callForwardingColumnConfig.getPerfColumns()),
    getColumnChooserConfiguration: () => {
      const lockedColumns = ['StartTime', 'EndTime', 'CallStatus', 'CallDuration'];

      const columnChooserConfig = {
        categories: [{
          name: i18n.getString('LevelOfDetail'),
          options: columnConfigToColumnChooserConfig(
            callForwardingColumnConfig.getLevelOfDetailColumns(level),
            lockedColumns
          ),
        }, {
          name: i18n.getString('Performance'),
          options: columnConfigToColumnChooserConfig(
            callForwardingColumnConfig.getPerfColumns(),
            lockedColumns
          ),
        }],
        selected: lockedColumns,
        mandatory: [],
        patchQuery: true,
        isForVNext,
      };

      if (isForVNext) {
        columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';
      }

      return columnChooserConfig;
    },

    getEntity: () => jsDataCampaign.Time,

    getEntitySet: () => _.result(edm.currentAccount, 'Time'),

    getSchema: () => {
      const columns = ['CampaignName', 'AdGroupName'];

      deleteSchema(columns, callForwardingSchema);

      if (level === Constants.AccountLevel) {
        callForwardingSchema.properties.CampaignName = { // eslint-disable-line no-param-reassign
          type: 'string',
          filterable: true,
          nullable: true,
        };
        callForwardingSchema.properties.AdGroupName = { // eslint-disable-line no-param-reassign
          type: 'string',
          filterable: true,
          nullable: true,
        };
      } else if (level === Constants.CampaignLevel) {
        callForwardingSchema.properties.AdGroupName = { // eslint-disable-line no-param-reassign
          type: 'string',
          filterable: true,
          nullable: true,
        };
      }

      return callForwardingSchema;
    },
    getReportName: () => 'CallForwardingDetail',
    getReportSchema() {
      return _.defaults({
        name: this.getReportName(gridType),
      }, this.getSchema(gridType));
    },
    modifyFilter: (filters) => {
      const callStatus = filters.fields.filter(item => item.name === 'CallStatus')[0];

      callStatus.chooseType = 'checkbox';
      callStatus.enum = [0, 1];
      callStatus.localized = {
        0: i18n.getString('Dimension_CallStatus_0'),
        1: i18n.getString('Dimension_CallStatus_1'),
      };
      callStatus.type = 'object';

      return filters;
    },
    getRewriteMap: () => ({
      StartTime: i18n.getString('ColumnName_StartTime'),
      EndTime: i18n.getString('ColumnName_EndTime'),
      AreaCode: i18n.getString('ColumnName_AreaCode'),
      City: i18n.getString('ColumnName_City'),
      StateOrProvince: i18n.getString('ColumnName_StateOrProvince'),
      CallStatus: i18n.getString('ColumnName_CallStatus'),
      CallDuration: i18n.getString('ColumnName_CallDuration'),
      PhoneSpend: i18n.getString('ColumnName_PhoneSpend'),
      AdGroupName: i18n.getString('FilterLocalization_DataAttribute_AdGroupName'),
      CampaignName: i18n.getString('FilterLocalization_DataAttribute_CampaignName'),
    }),
  };
}
